import React, { useState, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { register_admin_action } from '../../../_redux/action';
import { navigateRoutes } from '../../../_config/route';
import { errorMsg } from '../../../_helpers/errorConst';
import { emailCheck, passwordCheck, emptyStringCheck } from '../../../_helpers/formFieldErrorCheck';
import { AuthContext } from '../../../_hooks/useAuthContext';

function useSignUp(props) {
  //initial states
  const { setUser } = useContext(AuthContext);
  const [formData, setformData] = useState({});
  const [formInputsError, setFormInputsError] = useState({});
  const [loading, setloading] = useState(false);
  const [showPassword, setshowPassword] = useState(false);
  const [isAdmin, setIsAdmin] = useState(true);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  React.useEffect(() => {
    setformData({
      full_name: '',
      email: '',
      password: '',
    });
  }, []);

  //set states on input change
  const onInputChange = (value, key) => {
    let data = formData;
    data[key] = value;
    setformData(data);
  };

  // submit form
  const onSubmitClick = async (e) => {
    e.preventDefault();
    setloading(true);

    if (validateForm()) {
      formData.role = isAdmin ? 'ADMIN' : 'USER';
      let loginData;
      if (isAdmin) {
        loginData = await dispatch(register_admin_action(formData));
      }
      if (loginData?.data) {
        navigate('/');
        setUser(loginData?.data);
      }
    }
    setloading(false);
  };

  const handleShowPassword = (key) => {
    setshowPassword(!showPassword);
  };

  const checkFieldError = (val, name) => {
    if (emptyStringCheck(val)) {
      setFormInputsError({ ...formInputsError, [name]: errorMsg.emptyField });
    } else {
      setFormInputsError({ ...formInputsError, [name]: '' });
    }
    if (name === 'email') {
      if (!emailCheck(val)) setFormInputsError({ ...formInputsError, email: errorMsg.email });
    }
    if (name === 'password') {
      if (!passwordCheck(val)) setFormInputsError({ ...formInputsError, password: errorMsg.password });
      else setFormInputsError({ ...formInputsError, password: '' });

      return;
    }
  };

  const validateForm = () => {
    let val = true;
    let data = formInputsError;
    for (let i in formData) {
      if (emptyStringCheck(formData[i])) {
        data = { ...data, [i]: errorMsg.emptyField };
        val = false;
      } else if (formInputsError[i] && formInputsError[i].length > 0) {
        val = false;
      }
    }

    setFormInputsError(data);

    return val;
  };

  const onToggleAdmin = () => {
    setIsAdmin(!isAdmin);
  };

  const onForgetPassword = () => navigate(navigateRoutes.forgotPassword);
  const onSignInClick = () => navigate(navigateRoutes.signIn);

  return {
    formInputsError,
    loading,
    showPassword,
    isAdmin,

    onInputChange,
    onSubmitClick,
    handleShowPassword,
    onForgetPassword,
    onSignInClick,
    checkFieldError,
    onToggleAdmin,
  };
}

export default useSignUp;
